import { Component } from '@angular/core';
import { MunilyAreaPictureUploaderGallerySize } from 'src/app/common-components/area-picture-uploader-gallery/area-picture-uploader-gallery.types';

@Component({
  selector: 'app-area-picture-uploader-gallery-playground',
  templateUrl: './area-picture-uploader-gallery-playground.component.html',
  styleUrls: ['./area-picture-uploader-gallery-playground.component.scss'],
})
export class AreaPictureUploaderGalleryPlaygroundComponent {
  images: string[] = [];
  size: MunilyAreaPictureUploaderGallerySize = 'large';
  maxSlots = 5;
  disabled = false;
  lastEvent = '';

  readonly sizes: MunilyAreaPictureUploaderGallerySize[] = ['small', 'large'];

  newImageUrl = '';

  onImagesChange(urls: string[]): void {
    this.images = urls;
    this.lastEvent = `imagesChange (${urls.length} URLs) @ ${new Date().toLocaleTimeString()}`;
  }

  onUploadFiles(files: File[]): void {
    const names = files.map((f) => f.name).join(', ');
    this.lastEvent = `${this.lastEvent} | upload files (${files.length}): ${names}`;
  }

  addImageUrl(): void {
    if (!this.newImageUrl?.trim() || this.images.length >= this.maxSlots) {
      return;
    }
    this.images = [...this.images, this.newImageUrl.trim()];
    this.newImageUrl = '';
    this.lastEvent = `add url @ ${new Date().toLocaleTimeString()}`;
  }

}
